import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import { EuiButton, EuiText } from "@elastic/eui";
import React, { useState } from "react";

import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, REGION, S3_BUCKET } from "../Constants";

const s3Client = new S3Client({
    region: REGION,
    credentials: {
        accessKeyId: AWS_ACCESS_KEY_ID,
        secretAccessKey: AWS_SECRET_ACCESS_KEY,
    },
});

const UploadImageToS3WithNativeSdk = () => {
    const [progress, setProgress] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileInput = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const uploadFile = async (file) => {
        const upload = new Upload({
            client: s3Client,
            params: {
                ACL: "public-read",
                Body: file,
                Bucket: S3_BUCKET,
                Key: file.name,
            },
        });

        upload.on("httpUploadProgress", (evt) => {
            setProgress(Math.round((evt.loaded / evt.total) * 100));
        });

        try {
            await upload.done();
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div>
            <input type="file" onChange={handleFileInput} />
            <EuiButton size="s" onClick={() => uploadFile(selectedFile)}>
                {" "}
                Upload to S3
            </EuiButton>
            <EuiText style={{ marginTop: "20px", marginBottom: "10px" }}>Upload voortgang {progress}%</EuiText>
        </div>
    );
};

export default UploadImageToS3WithNativeSdk;
